import { useQuery } from "@tanstack/react-query";
import { apiGet } from "@/api/client";
import { qk } from "@/api/keys";
import { useAuthStore } from "@/stores/authStore";

export type CoachAction =
  | "review"
  | "lesson"
  | "weakness"
  | "diagnosis"
  | "later"
  | "daily_mission";

export interface CoachButton {
  label: string;
  action: CoachAction;
}

export interface WeaknessTarget {
  key: string;
  label: string;
}

export interface DailyMissionSummary {
  run_id: string;
  title: string;
  scene: string;
  icon_emoji: string | null;
  opening_copy: string;
  estimated_minutes: number;
  question_count: number;
  focus_labels: string[];
  status: string;
}

export interface CoachTodayResponse {
  message: string;
  reason: string;
  reason_text: string;
  recommended_action: CoachAction;
  buttons: CoachButton[];
  weakness_target: WeaknessTarget | null;
  daily_mission: DailyMissionSummary | null;
}

export function useCoachToday() {
  const token = useAuthStore((s) => s.token);
  return useQuery({
    queryKey: qk.coachToday(),
    queryFn: () => apiGet<CoachTodayResponse>("me/coach/today"),
    enabled: Boolean(token),
    staleTime: 5 * 60 * 1000, // coach message is "for today" — cache 5 min
  });
}
